module.exports = __webpack_public_path__ + "assets/img/sy-3.0263df8d.png";